import { FC, PropsWithChildren } from "react"
import { CatButton } from "@blocks-react/components/Button"
import { CatIconClose } from '@blocks-react/components/Icons/Close';
import { CatIconMenu } from '@blocks-react/components/Icons/Menu';

export type HamburgerMenuProps = {
  isActive: boolean;
  onClick: () => void;
}

export const HeaderMobileHamburgerMenu: FC<PropsWithChildren<HamburgerMenuProps>> = ({ isActive, onClick }) => {
  return (
    <CatButton
      className="c-top-nav__menu-button"
      aria-expanded={isActive}
      onClick={onClick}
      hideText
      size="md"
      variant="primary"
      inverted
      data-testid="header-hamburger-menu-icon"
    >
      {isActive ? (
        <CatIconClose data-testId="cat-icon-close" slot="before" />
      ) : (
        <CatIconMenu data-testId="cat-icon-menu" slot="before" size="lg" />
      )}
    </CatButton>
  )
}
